import { render, staticRenderFns } from "./AdditionalServicesInternational.vue?vue&type=template&id=74adeb74&"
import script from "./AdditionalServicesInternational.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicesInternational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports